import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

/**
 * - Added socialPrefs
 * - Added defaultExportColumns to socialPrefs & monitoringPrefs
 */
export function fromOnePointFourToOnePointFive(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.5';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    if (!newModel.socialPrefs) {
        newModel.socialPrefs = userAppPreferencesDefault.socialPrefs;
    }
    if (!newModel.monitoringPrefs.defaultExportColumns) {
        newModel.monitoringPrefs.defaultExportColumns = userAppPreferencesDefault.monitoringPrefs.defaultExportColumns;
    }
    return newModel;
}
